<template>
  <div v-if="loading" style="text-align: center; padding: 40px">
    <van-loading size="30px" type="spinner" vertical>加载中..</van-loading>
  </div>
  <div v-if="step == 1 && !loading" class="register">
    <h2>注册 CEO • 驾驶舱</h2>
    <van-form @failed="onFailed" @submit="onSubmit">
      <van-cell-group inset>
        <!-- 通过 pattern 进行正则校验 -->
        <van-cell class="pd0 no-border">
          <van-field
            v-model.trim="form.tenantCode"
            label="域名"
            :maxlength="20"
            placeholder="6-20位小写英文字母数字"
            required
            :rules="[
              { required: true, message: '请输入域名' },
              {
                pattern: /^[a-z0-9]{6,20}$/,
                trigger: 'onBlur',
                message: '请输入6-20位小写英文字母数字',
              },
              {
                validator: checkCode,
                trigger: 'onBlur',
                message: '域名已存在，请更换',
              },
            ]"
            size="large"
            @keyup="keyup"
          />
          <div class="http flex flex-wrap">
            <span class="title">驾驶舱：</span>
            <span>https://</span>
            <span class="line">{{ form.tenantCode }}</span>
            <span>.tengyucloud.com</span>
          </div>
        </van-cell>

        <!-- 通过 validator 进行函数校验 -->
        <van-field
          v-model.trim="form.tenantName"
          label="公司简称"
          :maxlength="8"
          placeholder="8个以内文字"
          required
          :rules="[{ required: true, message: '请输入公司简称' }]"
          size="large"
        />
        <!-- 通过 validator 返回错误提示 -->
        <van-field
          v-model="form.tenantDesc"
          label="公司全称"
          :maxlength="100"
          placeholder="公司全称"
          required
          :rules="[{ required: true, message: '请输入公司全称' }]"
          size="large"
          type="textarea"
        />
        <van-field
          v-model="form.industryName"
          is-link
          label="公司行业"
          name="picker"
          placeholder="点击选择行业"
          readonly
          required
          :rules="[
            { required: true, trigger: 'onChange', message: '选择行业' },
          ]"
          size="large"
          @click="showPicker = true"
        />
        <van-popup v-model:show="showPicker" position="bottom">
          <van-picker
            :columns="industryList"
            :columns-field-names="{ text: 'IndustryName', value: 'IndustryId' }"
            @cancel="showPicker = false"
            @confirm="onConfirm"
          />
        </van-popup>
      </van-cell-group>
      <div style="margin: 16px">
        <van-button
          block
          :loading="submitLoading"
          native-type="submit"
          type="primary"
        >
          提交
        </van-button>
      </div>
    </van-form>
  </div>
  <div v-if="step == 2" class="success">
    <p><van-icon color="#239561" name="success" size="60" /></p>
    <h2>您已完成{{ form.tenantName }}注册</h2>
    <h4>您的驾驶舱地址为：</h4>
    <h4>https://{{ form.tenantCode }}.tengyucloud.com (用电脑打开)</h4>
    <h4>
      <van-button type="primary" @click="copy">复制链接</van-button>
    </h4>
  </div>
</template>
<script>
  import store from '@/store'
  import { Toast, Dialog } from 'vant'
  import { wxShare } from '@/utils'
  export default {
    data() {
      return {
        form: {
          tenantCode: '',
          tenantName: '',
          tenantDesc: '',
          owner: '',
          industry: '',
          industryName: '',
        },
        loading: false,
        submitLoading: false,
        industryList: [],
        showPicker: false,
        step: 1,
        hasTenant: null,
        checkCode: (val) => {
          return new Promise((resolve, reject) => {
            store
              .dispatch('system/TenantAvailable', { code: val })
              .then((data) => {
                const { Data } = data
                if (Data) {
                  resolve(true)
                } else {
                  resolve(false)
                }
              })
              .catch((e) => {
                resolve(true)
              })
          })
        },
      }
    },
    created() {
      this.init()
    },
    methods: {
      async init() {
        this.loading = true
        await store.dispatch('user/getUserInfo').catch((e) => {
          this.loading = false
        })
        const userInfo = store.getters['user/getUserInfo']
        this.form.owner = userInfo.UserId
        if (userInfo.Account === userInfo.UserId) {
          // 说明用户还未进行设置accout 跳转至设置accout页面
          Dialog.alert({
            title: '温馨提示',
            confirmButtonText: '去注册',
            message: '您还未注册，将跳转至注册页面！',
          }).then(() => {
            this.$go('userRegister', {
              query: { redirect: this.$route.fullPath },
            })
            //router.back()
          })
        } else {
          // form.value.phone = userInfo.Phone
          // form.value.nickName = userInfo.NickName
          // form.value.userName = userInfo.UserName
        }

        const tenant = await store.getters['user/getTenant']
        // if (tenant.TenantCode != 'www') {
        //   this.$go('404')
        // }
        const routeName = this.$route.name
        let title = '注册CEO • 驾驶舱'
        if (routeName === 'TenantApply') {
          title = '注册体验CEO • 驾驶舱'
        }
        wxShare(`${tenant.TenantName}`, title)

        await store
          .dispatch('system/TenantGetListByOwner', {
            ownerId: this.form.owner,
          })
          .then((data) => {
            const { Data } = data
            if (Data.length) {
              const myTenant = []
              Data.forEach((item) => {
                if (item.Owner === this.form.owner) {
                  myTenant.push(item)
                }
              })
              if (myTenant.length) {
                this.hasTenant = myTenant[0]
                this.form.tenantCode = this.hasTenant.TenantCode
                this.step = 2
              }
            }
            this.loading = false
          })
          .catch((e) => {
            this.loading = false
          })

        this.loading = false

        await store.dispatch('system/IndustryGetAll').then((data) => {
          const { Data } = data
          const arr = []
          Data.forEach((item) => {
            arr.push({ text: item.IndustryName, value: item.IndustryId })
          })
          this.industryList = Data
        })
      },
      keyup(e) {
        this.form.tenantCode = this.form.tenantCode.replace(/[^a-z0-9]/g, '')
      },
      copy() {
        this.$copyText(`https://${this.form.tenantCode}.tengyucloud.com`).then(
          function (e) {
            Toast.success('复制成功')
          },
          function (e) {
            Toast.fail('复制失败，请手动复制')
          }
        )
      },
      onSubmit() {
        //const userInfo = store.getters['user/getUserInfo']
        //this.form.owner = userInfo.UserId
        this.submitLoading = true
        const routeName = this.$route.name
        let url = ''
        if (routeName === 'TenantRegister') {
          this.form.spId = 99999
          url = 'system/TenantRegister'
        } else {
          this.form.spId = 11111
          url = 'system/TenantApply'
        }
        store
          .dispatch(url, this.form)
          .then((data) => {
            const { Code, Data } = data
            if (Code === 0) {
              // Toast.success('提交成功')
              this.submitLoading = false
              setTimeout(() => {
                this.step = 2
              }, 500)
            } else {
              Toast.fail('提交失败')
            }
          })
          .catch((e) => {
            this.submitLoading = false
            Toast.fail(e.Message || '提交失败')
          })
      },
      onFailed(val) {
        Toast.fail(val.Message || '提交失败')
        this.submitLoading = false
      },
      onConfirm(val) {
        this.form.industryName = val.IndustryName
        this.form.industry = val.IndustryId
        this.showPicker = false
      },
    },
  }
</script>
<style lang="scss" scoped>
  .register {
    h2 {
      text-align: center;
      font-size: 20px;
      font-weight: normal;
      color: #555;
    }
  }
  .no-border {
    .van-cell::after {
      border: none;
    }
  }
  .http {
    margin-top: -4px;
    padding: 0 0 10px 24px;
    color: #999;
    line-height: 24px;
    span {
      display: inline-block;
      min-width: 40px;
      &.line {
        color: #f00;
        border-bottom: 1px solid #999;
        text-align: center;
      }
    }
  }
</style>
